export function Signup () {
  return () => import(`@/pages/signup`)
}

export function Login () {
  return () => import(`@/pages/login`)
}

export function JobsListWidget () {
  return () => import('@/pages/jobs-list-widget')
}



// WEBPACK FOOTER //
// ./src/helpers/lazy-routes.js